module.exports = __webpack_public_path__ + "static/media/logo.0946e973.png";